import "./App.css";
import "./styles/main.css";
import AlbumMainContainer from "./components/AlbumMainContainer";
import { Provider } from "react-redux";
import store from "./store.js";
import PageContent from "./components/PageContent/PageContent";

function App() {
  return (
    <Provider store={store}>
      <PageContent>
        <AlbumMainContainer />
      </PageContent>
    </Provider>
  );
}

export default App;
